import styled from 'styled-components'

import MenuEntryLink from '../MenuEntryLink'
import { desktopMenuLinkStyles } from '../styles/desktop-menu'

export const MainMenuEntryLink = styled(MenuEntryLink)`
  ${desktopMenuLinkStyles};
`
